var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-input",class:{ 'is-active': _vm.recording }},[(_vm.recording)?_c('div',{staticClass:"audio-loading"},_vm._l((6),function(item){return _c('div',{key:item})}),0):_c('span',{staticClass:"audio-text",on:{"touchstart":function($event){$event.preventDefault();return _vm.handleTouchstart.apply(null, arguments)},"touchend":_vm.handleTouchend}},[_vm._v("\n    按住 说话\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da6d0408","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/audioInput.vue
// module id = null
// module chunks = 